import { useState } from 'react';
import { RelativeDateBuilder } from '../RelativeDateBuilder';
import styles from '../SegmentVisualBuilder.module.css';
import { AbsoluteDateInput } from './AbsoluteDateInput';
import { DateValueModeToggle } from './DateValueModeToggle';
import { ResolvedDatePreview } from './ResolvedDatePreview';
import { getDateValueMode, isRelativeDate } from './date-value-utils';
import type { DateOperatorInputProps, DateValueMode } from './types';

export function GreaterLessThanDateInput({
  operator,
  value,
  onChange,
  disabled,
}: DateOperatorInputProps) {
  const [selectedDateValueMode, setSelectedDateValueMode] = useState<DateValueMode | null>(null);
  const derivedDateValueMode = getDateValueMode(value);
  const dateValueMode = derivedDateValueMode ?? selectedDateValueMode ?? 'relative';

  const handleDateValueModeChange = (nextDateValueMode: DateValueMode) => {
    setSelectedDateValueMode(nextDateValueMode);
    onChange([]);
  };

  return (
    <div className={styles.dateVariantWrapper}>
      <DateValueModeToggle
        dateValueMode={dateValueMode}
        onChange={handleDateValueModeChange}
        disabled={disabled}
      />
      {dateValueMode === 'absolute' ? (
        <AbsoluteDateInput value={value} onChange={onChange} disabled={disabled} />
      ) : (
        <RelativeDateBuilder
          value={value != null && isRelativeDate(value) ? value : null}
          onChange={rel => onChange([rel])}
          disabled={disabled}
        />
      )}
      <ResolvedDatePreview operator={operator} value={value} />
    </div>
  );
}
